import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../auth/api";
import { alertSuccess, alertError } from "../../components/Alert";

// Fetch Division List Data (with stateID)
export const fetchDivisionList = createAsyncThunk(
  "division/fetchDivisionList",
  async (stateID, { rejectWithValue }) => {
    try {
      let response;
      // console.log(stateID);

      if (!stateID || stateID === "undefined") {
        response = await api.get(`/location/panel/DivisionList`);
      } else {
        response = await api.get(`/location/panel/DivisionList?stateID=${stateID}`);
      }

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// Add Division to the List
export const addDivisionList = createAsyncThunk(
  "division/addDivisionList",
  async (newDivisionData, { rejectWithValue }) => {
    try {
      const response = await api.post("/location/panel/DivisionList", newDivisionData);
      alertSuccess(response.data.success);
      return newDivisionData;
    } catch (error) {
      console.log(error.message);
      alertError(error.response?.data.errors);
      return rejectWithValue(error.response?.data.errors || error.message);
    }
  }
);

// Update Division List Data
export const updateDivisionList = createAsyncThunk(
  "division/updateDivisionList",
  async (divisionData, { rejectWithValue }) => {
    try {
      const response = await api.patch("/location/panel/DivisionList", divisionData);
      alertSuccess(response.data.success);
      return response.data;
    } catch (error) {
      alertError(error.response?.data.errors);
      return rejectWithValue(error.response?.data.errors || error.message);
    }
  }
);

// Division List Slice
const divisionSlice = createSlice({
  name: "division",
  initialState: {
    divisionList: [],
    status: "idle",
    error: null,
  },
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch Division List
      .addCase(fetchDivisionList.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(fetchDivisionList.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.divisionList = action.payload;
      })
      .addCase(fetchDivisionList.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      // Add Division
      .addCase(addDivisionList.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(addDivisionList.fulfilled, (state, action) => {
        state.status = "succeeded";
      })
      .addCase(addDivisionList.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      // Update Division List
      .addCase(updateDivisionList.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(updateDivisionList.fulfilled, (state) => {
        state.status = "succeeded";
      })
      .addCase(updateDivisionList.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      });
  },
});

export const { clearError } = divisionSlice.actions;

export default divisionSlice.reducer;
